'use client'

import Section from '@lyra/core/components/Section'
import PageWithBanner from '@lyra/web/components/layout/PageWithBanner'
import YieldTable from '@lyra/web/containers/common/YieldTable'
import LendSection from '@lyra/web/containers/lend/LendSection'
import YieldSummaryItems from '@lyra/web/containers/yield/YieldSummaryItems'
import React from 'react'

export default function EarnPageHelper() {
  return (
    <PageWithBanner bannerTitle="Earn" bannerSubtitle="Grow your crypto with vaults and lending">
      <LendSection isLarge noTopBorder showSubaccountSwitch showConnectPrompt />
      <Section isLarge>
        <Section.Header title="Vaults" />
        <Section.XStack>
          <YieldSummaryItems />
        </Section.XStack>
        <Section.Table>
          <YieldTable />
        </Section.Table>
      </Section>
    </PageWithBanner>
  )
}
